module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl1-50.f5fbba13.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-B-lvl1-50.png
// module id = 3378
// module chunks = 11